<!-- 充值 -->
<template>
<div class='recharge'>
  <Head :goBack='true' :backPath="'/mall/phone/personal'" show="" title="会员充值"></Head>
  <div class="recharge_kong">&nbsp;</div>
  <div class="recharge-bg">
      <span class="money-title">账户余额(元)</span>
      <h3 class="money">{{personal.userMoney}}</h3>
      <div class="recharge-details-type">
        <span class="top-up-ico">&nbsp;</span><span class="top-up"  @click="torechargeDetail">充值记录</span><span class="transverse-line">&nbsp;</span><span class="deal-ico">&nbsp;</span><span  @click="opnDealDetail" class="deal">交易明细</span>
      </div>
  </div>
  <div class="set-meal" v-if="dataList.length">
    <div class="set-meal-title"><em>&nbsp;</em> 选择套餐</div>
    <ul class="set-meal-url">
      <li :class="item.id==additive?'set-meal-li':'set-meal-li additive'" v-for="(item,i) in dataList" :key="i" @click="changeSetMeal(item)">
          <span class="title-box"> 
            <span class="title">{{item.title}}</span>
          </span>
          <span class="money-ico">￥</span><span class="acquire-money">{{item.rechargeMoney*1+item.giveMoney*1}}</span>
          <span class="set-meal-introduce">充{{item.rechargeMoney}}送{{item.giveMoney}}等于{{item.rechargeMoney*1+item.giveMoney*1}}元</span>
          <div class="real-money-box"><span class="selling-price">售价&nbsp;</span><span class="real-money">{{item.rechargeMoney}}元</span></div>
      </li>
    </ul>
  </div>
   <van-goods-action v-if="dataList.length">
     <van-goods-action-button type="danger" v-if="show" class="goods-go" @click="payBtn">立即支付 {{price}}元</van-goods-action-button>
     <van-goods-action-button type="danger" loading loading-type="spinner" v-else class="goods-go" />
  </van-goods-action>
  <mobile-talk ref="mobile"/>
</div>
</template>

<script>
import {mapState,mapActions} from "vuex";
import { Toast  } from "vant";
import MobileTalk from "@/components/MobileTalk";
export default {
//import引入的组件需要注入到对象中才能使用
components: {
  mobileTalk:MobileTalk,
},
data() {
//这里存放数据
return {
  selectedPrice: {},
  dataList:[],
  price:'',
  additive:'',
  out_trade_no:'',
  show:true
};
},
//监听属性 类似于data概念
computed:{
  ...mapState(['personal'])
},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  ...mapActions(['getUserMoney']),
  // 获取套餐选项
  getRechargeList(){
    let data={
      deviceNum:this.deviceNum
    }
    this.$api.recharge.getRechargeList(data).then((res)=>{
      if(res.code==200){
        this.dataList=res.data
        if(res.data.length>0){
            this.price=res.data[0].rechargeMoney
            this.additive=res.data[0].id
        }
      }else{
        Toast(res.msg)
      }
    })
  },
  // 点击充值
  payBtn(){
    if(this.loginType==2){
      let data={
        deviceNum:this.deviceNum,
        rechargeId:this.additive
      }
      this.$api.recharge.rechargeCreateOrder(data).then((res)=>{
        if(res.code==200){
          this.out_trade_no=res.data.out_trade_no
          this.show=true
          this.onBridgeReady(res.data)
        }else if(res.code==406){
          this.show=true
          this.$refs.mobile.control()
        }else{
          this.show=true
          Toast(res.msg)
        }
      }).catch((err) =>{ 
        this.show=true
      });
    }else if(this.loginType==1){
      this.show=true
      Toast("支付宝充值暂未开放")
    }
  },
  onBridgeReady(params){
    let that=this
    // 微信支付签名接口
     WeixinJSBridge.invoke(
      'getBrandWCPayRequest', {
        appId: params.appId, // 公众号名称，由商户传入
        timeStamp: params.timeStamp, // 时间戳，自1970年以来的秒数
        nonceStr: params.nonceStr, // 随机串
        package: params.package,
        signType: params.signType, // 微信签名方式：
        paySign: params.paySign, // 微信签名
      },
      function(res){
        if(res.err_msg == "get_brand_wcpay_request:ok" ){
          that.getUserMoney()
          Toast("支付成功")
        } else if(res.err_msg =='get_brand_wcpay_request:cancel'){
          Toast("您已取消了支付")
        }else{
          Toast("支付失败，请重新支付")
        }
      }
    )
  },
  // 选择套餐
  changeSetMeal(item){
    this.additive=item.id
    this.price=item.rechargeMoney
  },
  torechargeDetail() {
    // Toast("暂未开放")
    this.$router.push({
      name: 'rechargeDetails', query: {type:1}
    })
  },
  opnDealDetail(){
    this.$router.push({
      name: 'rechargeDetails', query: {type:2}
    })
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.getRechargeList()
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
.recharge_kong{
  width: 100%;
  height: 100px;
}
.recharge{
  background-color: #fff;
  .recharge-bg{
    text-align: center;
    width: 695px;
    height: 301px;
    margin:33px 27px 6px;
    border-radius:20px ;
    color: #fee8c3;
    background: url('~@/assets/images/yuebeijing.png') no-repeat center center;
    background-size:100% 100% ;
    border: 1px solid #828282;
    .money-title{
      font-size: 26px;
      margin-top: 28px;
      line-height: 47px;
    }
    .money{
      font-size: 60px;
      line-height: 84px;
      font-weight:bold;
    }
    .recharge-details-type{
      text-align: center;
      margin-top: 76px;
      .top-up{
        display: inline-block;
        height: 45px;
        line-height: 45px;
        margin-right: 103px;
      }
      .top-up-ico{
        display: inline-block;
        width: 27px;
        height: 45px;
        line-height: 45px;
        margin-right: 15px;
        background: url('~@/assets/images/chongzhijilu.png') no-repeat center center;
        background-size:100% auto ;
      }
      .transverse-line{
        display: inline-block;
        width: 4px;
        height: 45px;
        line-height: 45px;
        background: url('~@/assets/images/shu.png') no-repeat center center;
        background-size:100% 100% ;
      }
      .deal{
        height: 45px;
        line-height: 45px;
        display: inline-block;
      }
      .deal-ico{
        display: inline-block;
        width: 27px;
        height: 45px;
        line-height: 45px;
        background: url('~@/assets/images/jiaoyimingxi.png') no-repeat center center;
        margin-left: 101px;
        margin-right: 15px;
        background-size:100% auto ;
      }
    }
  }
  .set-meal{
    margin: 0 27px;
    .set-meal-title{
      padding: 46px 0;
      line-height: 30px;
      font-size: 30px;
      color: #2b2f45;
      font-weight:bold;
      em{
        display: inline-block;
        margin-left: 14px;
        margin-right: 20px;
        height: 21px;
        width: 43px;
        position: relative;
        top: 5px;
        background: url('~@/assets/images/discounts.png') no-repeat center center;
        background-size:100% 100% ;
      }
    }
    .set-meal-url{
      .set-meal-li{
        height: 130px;
        width: 100%;
        background-color: #1fb865;
        margin-bottom: 65px;
        color: #fff;
        border-radius:17px ;
        position: relative;
        overflow: hidden;
        .title-box{
          position: absolute;
          top: -0px;
          width: 102px;
          height: 60px;
          background: url('~@/assets/images/biaoqianxuanzhong.png') no-repeat center center;
          background-size:100% 100% ;
           .title{
            display:block;
            line-height: 24px;
            width: 100%;
            font-style: 24px;
            transform:rotate(-30deg);
            overflow:hidden; //超出的文本隐藏
            white-space:nowrap; //不换行
            color: #2c334f;
          }
        }
        .money-ico{
          line-height: 130px;
          font-size: 18px;
          margin-left: 32px;
          margin-right: 4px;
        }
        .acquire-money{
          font-size: 44px;
          font-weight:bold;
          position: relative;
          top: 6px;
          display: inline-block;
          width: 134px;
        }
        .set-meal-introduce{
          font-size: 28px;
        }
        .real-money-box{
          display: inline-block;
          position: relative;
          top: 0;
          right: 30px;
          float:right;
          .selling-price{
            font-size: 28px;
            display: block;
            text-align: right;
            padding-top: 20px;
          }
          .real-money{
            font-size: 38px;
            text-align: center;
            display: block;
          }
        }
      }
      .additive{
        color: #545454;
        background-color: #e9e9e9;
        .title-box{
          background: url('~@/assets/images/biaoqianweixuanzhong.png') no-repeat center center;
          background-size:100% 100% ;
          .title{
            color:#fff;
          }
        }
      }
    }
  }
  .goods-go{
    height: 85px;
    background: #13A556 !important;
    border-radius: 14px;
    font-size: 26px;
    margin:0 27px;
  }
}
</style>